export default __webpack_public_path__ + "images/hero.21dfd3437e4358c29e421d5cef0c4f2e.png";